module.exports = __webpack_public_path__ + "img/sb.770034a3.svg";